import React, { useEffect } from 'react';
import { Flex, Box } from '@chakra-ui/layout';
import { MainRoutes } from 'routes';
import { RouteComponentProps } from 'react-router';
import { routePaths } from 'constants/routes';
import { Sidebar, Topbar } from './components';

interface IProps extends RouteComponentProps {}

export const Main: React.FC<IProps> = ({ location, history }) => {
  useEffect(() => {
    if (location.pathname === routePaths.main) {
      history.push(routePaths.home);
    }
  }, []);

  return (
    <div style={{ position: 'relative', zIndex: 200 }}>
      <Flex>
        <Box zIndex="1000" position="sticky" top="0" h="100vh" bg="brand.1300" w="240px">
          <Sidebar />
        </Box>
        <Flex direction="column" flex={1}>
          <Box zIndex="999" position="sticky" top="0" w="100%">
            <Topbar />
          </Box>
          <Box overflow="auto" w="100%" height="100%" display="flex" padding="2rem">
            <MainRoutes />
          </Box>
        </Flex>
      </Flex>
    </div>
  );
};
